export const HEIGHT_MOBILE = 71;
export const COLLAPSED_DESKTOP_WIDTH = 56;
export const EXPANDED_DESKTOP_WIDTH = 176;
//# sourceMappingURL=constants.js.map